import type { EquipmentCostCategory } from '@acceligentllc/shared/enums/equipmentCostCategory';

import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type BaseRouteDefinition = `${typeof baseRoute}/${EquipmentCostCategory | ':type'}/group`;

type QueryRouteDefinition = `${typeof baseRoute}/${EquipmentCostCategory | ':type'}/group${`?year=${string}` | ''}`;

type RouteDefinition = BaseRouteDefinition | QueryRouteDefinition;

export const ROUTE: RouteDefinition = `${baseRoute}/:type/group`;

export const URL = (type: EquipmentCostCategory, year?: string): RouteDefinition => year
	? `${baseRoute}/${type}/group?year=${year}`
	: `${baseRoute}/${type}/group`;
